export default __webpack_public_path__ + "static/media/Rampver-Online-Logo-(Long).fa3dd774.png";